import { createStore,applyMiddleware,combineReducers } from "redux";
import {thunk} from "redux-thunk";

import {rootReducer,undo} from "./reducers";

const store = createStore(combineReducers({
    rootReducer,undo
  }),applyMiddleware(thunk));

export default store;